"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var AiOutlineQuestionCircle_1 = require("@react-icons/all-files/ai/AiOutlineQuestionCircle");
var styles_1 = require("../../styles");
var context_1 = require("../../context/context");
var Components_1 = require("../Components");
function Label(_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (0, jsx_runtime_1.jsx)(StyledContainer, __assign({ className: "twap-label ".concat(className) }, { children: children }));
}
exports.Label = Label;
var Text = function (_a) {
    var text = _a.text, fontSize = _a.fontSize;
    return ((0, jsx_runtime_1.jsx)(StyledLabel, __assign({ className: "twap-label-text", style: { fontSize: fontSize } }, { children: text })));
};
var Info = function (_a) {
    var text = _a.text;
    var uiPreferences = (0, context_1.useTwapContext)().uiPreferences;
    var InfoIcon = (uiPreferences === null || uiPreferences === void 0 ? void 0 : uiPreferences.infoIcon) || (0, jsx_runtime_1.jsx)(AiOutlineQuestionCircle_1.AiOutlineQuestionCircle, {});
    return ((0, jsx_runtime_1.jsx)(Components_1.Tooltip, __assign({ tooltipText: text }, { children: (0, jsx_runtime_1.jsxs)(StyledInfo, { children: [" ", InfoIcon] }) })));
};
Label.Text = Text;
Label.Info = Info;
var StyledInfo = (0, styled_components_1.default)(styles_1.StyledRowFlex)({
    position: "relative",
    top: 1,
});
var StyledContainer = (0, styled_components_1.default)(styles_1.StyledRowFlex)({
    justifyContent: "center",
    gap: 7,
    width: "fit-content",
});
var StyledLabel = (0, styled_components_1.default)(styles_1.StyledText)({
    fontSize: "inherit",
    fontFamily: "inherit",
});
